// Single source of truth for "is this a demo build / demo session?".
//
// Two ways in, deliberately separate:
//
//   1. `VITE_DEMO=1` at BUILD time  → the public sales demo bundle
//      (`npm run build:demo`, deployed to deskte.com/demo/app/). The whole
//      bundle is a demo: no login, no backend, fictional SEED_* data only.
//
//   2. `?demo=1` in DEV             → the local screenshot/tutorial mode that
//      already existed (see crm-app/capturas.mjs). Unchanged.
//
// The production app bundle (app.deskte.com) sets neither, so both branches
// are statically false and every demo-only code path is dead-code-eliminated
// by esbuild. app.deskte.com can never be opened in demo mode — that property
// is what made the original dev-only gate safe, and it is preserved here.
export const IS_DEMO_BUILD = import.meta.env.VITE_DEMO === '1';

// Solo en DESARROLLO (`?demo=1&plataforma=1`): ver la demo como la dueña de
// la plataforma, para enseñar lo que solo ella ve (p. ej. la carga de PDFs del
// catálogo base). La demo pública (VITE_DEMO=1) y app.deskte.com nunca lo
// encienden: en esos bundles `import.meta.env.DEV` es false.
export const DEMO_COMO_PLATAFORMA = import.meta.env.DEV
  && typeof window !== 'undefined'
  && new URLSearchParams(window.location.search).has('demo')
  && new URLSearchParams(window.location.search).has('plataforma');

export const IS_DEMO = IS_DEMO_BUILD
  || (import.meta.env.DEV
      && typeof window !== 'undefined'
      && new URLSearchParams(window.location.search).has('demo'));
